import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar: React.FC = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    await logout();
  };

  const handleProfile = (): void => {
    navigate('/profile');
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <button 
            className="nav-link btn btn-link" 
            data-widget="pushmenu" 
            type="button"
            style={{ border: 'none', background: 'none', padding: '0.5rem 0.75rem' }}
          >
            <i className="fas fa-bars"></i>
          </button>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <a href="/dashboard" className="nav-link">Home</a>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown">
          <button
            className="nav-link btn btn-link dropdown-toggle"
            data-toggle="dropdown"
            type="button"
            style={{ border: 'none', background: 'none', padding: '0.5rem 0.75rem' }}
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i className="fas fa-user-circle"></i> {user?.name || user?.email}
          </button>
          <div className="dropdown-menu dropdown-menu-right">
            <button className="dropdown-item" onClick={handleProfile} type="button">
              <i className="fas fa-user mr-2"></i> Meu Perfil
            </button>
            <div className="dropdown-divider"></div>
            <button className="dropdown-item" onClick={handleLogout} type="button">
              <i className="fas fa-sign-out-alt mr-2"></i> Sair
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;